import { useEffect, useState } from "react";
import { createWeb3Modal, defaultWagmiConfig } from "@web3modal/wagmi/react";
import { configureChains, createConfig, WagmiConfig } from "wagmi";
import { polygon } from "wagmi/chains";

import { Route, Switch, BrowserRouter } from "react-router-dom";
import HeaderSection from "../HeaderSection";
import HomeScreen from "../HomeScreen";
import InformationScreen from "../InformationScreen";
import AttentionModal from "../AttentionModal";
import { BlockchainContextProvider } from "../../store/BlockchainContext";

import DisconnectModal from "../DisconnectModal";
import DepositModal from "../DepositModal";

const projectId = "0219caafa3efe586522bb29f82966412";
const chains = [polygon];

const metadata = {
  name: "Matic.Capital",
  description: "Matic.Capital",
  url: "https://matic.capital/",
  icons: ["https://avatars.githubusercontent.com/u/37784886"],
  // icons: ["https://matic.capital/favicon.ico"],
};

const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata });

// const { publicClient } = configureChains(chains, [w3mProvider({ projectId })]);
// const wagmiConfig = createConfig({
//   autoConnect: true,
//   connectors: w3mConnectors({ chains, projectId }),
//   publicClient,
// });
createWeb3Modal({ wagmiConfig, projectId, chains });

const App = () => {
  const [open, setopen] = useState(false);

  useEffect(() => {
    if (window.location.href.includes("?ref=")) {
      let getAddress = window.location.href.split("?ref=")[1];
      let final = getAddress;
      localStorage.setItem("baseRef", final);
    }
    if (localStorage.getItem("appVersion") === process.env.REACT_APP_VERSION) {
    } else {
      // caches.keys().then((names) => {
      //   names.forEach((name) => {
      //     caches.delete(name);
      //   });
      // });
      localStorage.setItem("appVersion", process.env.REACT_APP_VERSION);
    }
    if (localStorage.getItem("showModal") !== "false") {
      setopen(true);
    }
  }, []);

  return (
    <WagmiConfig config={wagmiConfig}>
      <BlockchainContextProvider>
        <DisconnectModal />
        <DepositModal />

        <BrowserRouter>
          <div className="wrapper">
            {open && <AttentionModal handleClose={() => setopen(false)} />}
            <HeaderSection />
            <Switch>
              <Route path="/" exact component={HomeScreen} />
              {/* <Route path="/info" component={InformationScreen} /> */}
            </Switch>
          </div>
        </BrowserRouter>
      </BlockchainContextProvider>
    </WagmiConfig>
  );
};

export default App;
